/**
 * Crea un array di stringhe da visualizzare a partire da un RTCStatsReport.
 * @param {RTCStatsReport} report - Il report RTCStats corrente.
 * @param {RTCStatsReport} lastReport - L'ultimo RTCStatsReport disponibile.
 * @return {Array<string>} - Array di stringhe da visualizzare.
 */
export function createDisplayStringArray(
    r: RTCStatsReport,
    lr?: RTCStatsReport
): string[] {

    const report: Map<string, any> = new Map<string, any>();
    const lastReport: Map<string, any> = new Map<string, any>();

    if (lr) {
        lr.forEach(stat => {
            lastReport.set(stat.id, stat);
        });
    }

    r.forEach(stat => {
        report.set(stat.id, stat);
    });



    const array: string[] = [];

    report.forEach(stat => {
        if (stat.type === 'inbound-rtp') {
            array.push(`${stat.kind} receiving stream stats`);

            if (stat.codecId !== undefined) {
                const codec = report.get(stat.codecId);
                if (codec) {
                    array.push(`Codec: ${codec.mimeType}`);

                    if (codec.sdpFmtpLine) {
                        codec.sdpFmtpLine.split(";").forEach((fmtp: any) => {
                            array.push(` - ${fmtp}`);
                        });
                    }

                    if (codec.payloadType !== undefined) {
                        array.push(` - payloadType=${codec.payloadType}`);
                    }

                    if (codec.clockRate !== undefined) {
                        array.push(` - clockRate=${codec.clockRate}`);
                    }

                    if (codec.channels !== undefined) {
                        array.push(` - channels=${codec.channels}`);
                    }
                }
            }

            if (stat.kind === "video") {
                array.push(`Decoder: ${stat.decoderImplementation}`);
                array.push(`Resolution: ${stat.frameWidth}x${stat.frameHeight}`);
                array.push(`Framerate: ${stat.framesPerSecond}`);
            }

            if (lastReport && lastReport.get(stat.id)) {
                const lastStats = lastReport.get(stat.id);
                if (lastStats) {
                    const duration = (stat.timestamp - lastStats.timestamp) / 1000;
                    const bitrate = (8 * (stat.bytesReceived - lastStats.bytesReceived) / duration) / 1000;
                    array.push(`Bitrate: ${bitrate.toFixed(2)} kbit/sec`);
                }
            }
        } else if (stat.type === 'outbound-rtp') {
            array.push(`${stat.kind} sending stream stats`);

            if (stat.codecId !== undefined) {
                const codec = report.get(stat.codecId);
                if (codec) {
                    array.push(`Codec: ${codec.mimeType}`);

                    if (codec.sdpFmtpLine) {
                        codec.sdpFmtpLine.split(";").forEach((fmtp: any) => {
                            array.push(` - ${fmtp}`);
                        });
                    }

                    if (codec.payloadType !== undefined) {
                        array.push(` - payloadType=${codec.payloadType}`);
                    }

                    if (codec.clockRate !== undefined) {
                        array.push(` - clockRate=${codec.clockRate}`);
                    }

                    if (codec.channels !== undefined) {
                        array.push(` - channels=${codec.channels}`);
                    }
                }
            }

            if (stat.kind === "video") {
                array.push(`Encoder: ${stat.encoderImplementation}`);
                array.push(`Resolution: ${stat.frameWidth}x${stat.frameHeight}`);
                array.push(`Framerate: ${stat.framesPerSecond}`);
            }

            if (lastReport && lastReport.get(stat.id)) {
                const lastStats = lastReport.get(stat.id);
                if (lastStats) {
                    const duration = (stat.timestamp - lastStats.timestamp) / 1000;
                    const bitrate = (8 * (stat.bytesSent - lastStats.bytesSent) / duration) / 1000;
                    array.push(`Bitrate: ${bitrate.toFixed(2)} kbit/sec`);
                }
            }
        }
    });

    return array;
}
